import { type AemData } from '@dh-io-owpi/shared/src/plugins/aemData';

/**
 * Get the BM4 data for the vehicle model series using the VMDS API and AEM data.
 */
export function getBM4({ stage, country, language, modelSeries }: AemData) {
  const prefix = stage === 'PROD' ? '' : 'int.';
  return fetch(
    `https://${prefix}api.oneweb.mercedes-benz.com/vmds-api/v1/vehicles/${country}/${language}/model-series/${modelSeries}`,
  )
    .then((r) => r.json())
    .then((data) => data.bm4);
}
